import * as React from 'react';
import './Header.css';

const Header = () => {
    return (
        <div className='header'>
            <div>DPS</div>
        </div>
    );
}

export default Header;